import React from 'react';
import {LABELTEXT, VERSION, VERSIONMIN} from './api/Globals';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer grid">
            <span className="font-medium col-12 text-center p-0">Versión {VERSIONMIN} © 2026 Secretaría de Educación y Cultura. Entrega de {LABELTEXT} Escolares</span>
            <span className="font-medium col-12 text-center p-0">Desarrollado por la Unidad de Tecnologías de la Información, Comunicación e Innovación Educativa</span>
        </div>
    );
}
